import PartKayuApi from './PartKayuApi';

export default PartKayuApi;
